import { PropGetter } from '@chakra-ui/react-utils';
import { ariaAttr } from '@chakra-ui/utils';
import { CSSProperties, useCallback, useMemo } from 'react';
import { useRangeSliderContext } from './range-slider-context';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useRangeSliderRoot = () => {
  const { isDisabled } = useRangeSliderContext();

  const rootStyle = useMemo<CSSProperties>(
    () => ({
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      touchAction: 'none',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      userSelect: 'none',
      outline: 0,
    }),
    []
  );

  const getRootProps: PropGetter = useCallback(
    // eslint-disable-next-line no-null/no-null
    (props = {}, ref = null) => ({
      ...props,
      ref,
      tabIndex: -1,
      'aria-disabled': ariaAttr(isDisabled),
      style: {
        ...props.style,
        ...rootStyle,
      },
    }),
    [isDisabled, rootStyle]
  );

  return {
    getRootProps,
  };
};
